module.exports = __webpack_public_path__ + "img/197.blockage_toilet.9f9d5596.svg";